export const BASE_URL = 'https://soukw.com.br:3000'
export const SOUKW_URL = 'https://soukw.com.br/'
// export const BASE_URL = 'http://localhost:3001'
// export const SOUKW_URL = 'http://localhost:3000/'
